<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: black;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">XPPL</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Pirate library, web application</p>
        <p>
        XPPL is a space for potential pirate librarianship. It is both an experiment and a working prototype for a distributed network catalogue and library that you can run and install on several machines and share/synchronise with the same bibliographical database.</p>
        <p>Initially developed as a in-house tool for the XPUB course, XPPL is a project aimed at people who are studying within and outside formal education. XPPL provides a web interface and hosts a curated catalogue of books and articles. Its distributed architecture is open to instances of uploading and downloading, and allows for the collective editing of its content. In XPPL, librarians can add and modify small collections of books that are connected by threads of thought, or follow a certain thematic or study path.</p>
        <p>My main focus within the library revolved around the notion of stacks. Rather than a bookshelf in a library, where books are lined up and often forgotten, the stacks on your table/nightstand/bathroom floor consist of books prone to be opened and reopened at any time. The stacks in XPPL are visible for others in the network to browse, annotate, update or shuffle. </p>
        <p>Find the project <a href="https://issue.xpub.nl/06/" target="_blank">here</a> and <a href="https://git.xpub.nl/XPUB/XPPL" target="_blank">here</a> as well.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/xppl/xppl.gif"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/xppl/xppl_main.png"></b-img>
      </b-col>

      <b-col md="4">
      <b-img class="img-fluid" src="media/xppl/xppl_stack.png"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/xppl/add.png"></b-img>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'XpplPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }

}

</script>
